import { render, staticRenderFns } from "./FeedbackEditors.vue?vue&type=template&id=6117b256&"
import script from "./FeedbackEditors.vue?vue&type=script&lang=js&"
export * from "./FeedbackEditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports